<template>
  <div class="">
    <div class="targets-head-box">
      <div>
        Driving safely <br />
        Gain rewards
      </div>
    </div>
    <div class="targets-body-box">
      <div class="targets-title-box">Reduce Speeding times</div>
      <div class="targets-tips-box">Achieve the goals to earn kudos!</div>
      <div class="targets-content-box">
        <div class="targets-content bc-speeding">
          <div class="targets-content-title">
            Reduce speeding to 3 times per week
          </div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
        <div class="targets-content bc-speeding">
          <div class="targets-content-title">
            Reduce speeding to 3 times per week
          </div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="targets-body-box">
      <div class="targets-title-box">Keep Online</div>
      <div class="targets-tips-box">Achieve the goals to earn kudos!</div>
      <div class="targets-content-box">
        <div class="targets-content bc-keep-online">
          <div class="targets-content-title">Keep online for next 2 weeks</div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
        <div class="targets-content bc-keep-online-two">
          <div class="targets-content-title">Keep online for next 2 weeks</div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="targets-body-box">
      <div class="targets-title-box">Reduce Braking events</div>
      <div class="targets-tips-box">Achieve the goals to earn kudos!</div>
      <div class="targets-content-box">
        <div class="targets-content bc-braking">
          <div class="targets-content-title">
            Reduce harsh braking to 3 times per week
          </div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
        <div class="targets-content bc-braking">
          <div class="targets-content-title">
            Reduce harsh braking to 3 times per week
          </div>
          <div class="targets-content-time">
            <div>in 15 days</div>
            <div>
              <van-icon
                class="targets-content-time-icon"
                name="star"
                color="#fff"
              />20
            </div>
          </div>
        </div>
      </div>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import "echarts";
import Tabbar from "@/components/Tabbar";
export default {
  components: {
    Tabbar,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.targets-head-box {
  width: 361px;
  height: 96px;
  margin: 16px auto;
  overflow: hidden;
  background: url("../../assets/image/targets-bc.png");
  background-repeat: no-repeat;
  background-size: cover;
  div {
    width: 167px;
    height: 58px;
    font-size: 24px;
    font-family: SFPro, SFPro;
    font-weight: 900;
    color: #7a808a;
    line-height: 29px;
    margin: 19px;
    font-style: oblique;
  }
}
.targets-body-box {
  width: 361px;
  height: 152px;
  margin: 0 auto;
  .targets-title-box {
    width: 234px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #200e32;
    line-height: 25px;
    margin-bottom: 2px;
  }
  .targets-tips-box {
    width: 234px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #b4afba;
    line-height: 17px;
    margin-bottom: 12px;
  }
  .targets-content-box {
    width: 361px;
    height: 96px;
    display: flex;
    justify-content: space-between;
    .targets-content {
      border-radius: 12px;
      width: 175px;
      height: 96px;
      background: linear-gradient(225deg, #58b6f5 0%, #408de9 100%);
      .targets-content-title {
        width: 147px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
        margin: 12px 14px 14px 14px;
      }
      .targets-content-time {
        width: 147px;
        height: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 14px;
        div:nth-child(1) {
          width: 74px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
        }
        div:nth-child(2) {
          width: 39px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 20px;
          .targets-content-time-icon {
            margin-right: 4px;
          }
        }
      }
    }
  }
}
.divider {
  width: 360px;
  height: 1px;
  // border: 1px solid #e7e7e7;
  margin: 16px auto;
  background: #e7e7e7;
}
.bc-braking{
  background: linear-gradient(225deg, #76E46A 0%, #53DB65 100%) !important;
}
.bc-keep-online{
  background: linear-gradient(225deg, #6663EA 0%, #5553DB 100%) !important;
}
.bc-keep-online-two{
  background: linear-gradient(225deg, #6663EA 0%, #5553DB 100%) !important;
  opacity: 0.4;
}

</style>